import * as types from "./mutation-types";

export default {
  [types.USER_INFO](state, anselmUserInfo) {
    state.anselmUserInfo = anselmUserInfo;
  },
  [types.IS_LOGIN](state, isLogin) {
    state.isLogin = isLogin;
  },
  [types.PRODUCT_DATA](state, productData) {
    state.productData = productData;
  },
  [types.DEFAULT_SELECT_MENU](state, defaultSelectMenu) {
    state.defaultSelectMenu = defaultSelectMenu;
  },
  [types.MANUAL_DATA](state, manualData) {
    state.manualData = manualData;
  },
  [types.VIDEO_DATA](state, videoData) {
    state.videoData = videoData;
  },
  [types.SYNOPSIS_DATA](state, synopsisData) {
    state.synopsisData = synopsisData;
  },
  [types.LANGUAGE](state, language) {
    state.language = language;
  },
  [types.ABOUT_CONTACT](state, aboutContact) {
    state.aboutContact = aboutContact;
  }
};
